import { Box, Stack, Avatar, Typography } from "@mui/material";
import "./styles.css";

const SidebarPortal = ({ children }) => {
  return <Box className="sidebar-portal">{children}</Box>;
};

export default SidebarPortal;
